import { Reveal } from '../primitives'

const POINTS = [
  { name: 'Route', body: 'Pick your stops or import a GPX. Add dispersed camps and detours along the way.' },
  { name: 'Crew', body: 'Keep your overlanding circle in one place and invite them to a trip in two taps.' },
  { name: 'Meals and gear', body: "See who's cooking and who's bringing what. Dietary conflicts surface on their own." },
  { name: 'Weather', pro: true, body: 'Overnight lows, wind and rain windows for every stop, not a city forecast.' },
  { name: 'Campsite finder', pro: true, body: 'Pull-offs and dead-end spurs near your route when your first choice is taken.' },
  { name: 'Ranger', pro: true, body: 'Say where and when. The trip assistant starts the trip and does the naming.' },
]

export function IntroSection() {
  return (
    <section className="pt-[var(--l-section)]">
      <div className="l-frame">
        <Reveal className="l-lead max-w-[30em]">
          <h2 className="inline font-normal">Group chats bury the plan. </h2>
          <p className="l-soft inline">
            SitRepp keeps the route, the crew, the meals and the gear in one place, and it stays true when the plan
            changes.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:mt-20 lg:grid-cols-3">
          {POINTS.map((point, index) => (
            <Reveal as="li" key={point.name} delay={(index % 3) * 60} className="max-w-[34ch]">
              <span className="font-medium">
                {point.name}
                {point.pro && <span className="l-soft font-normal"> · Pro</span>}
              </span>
              <span className="l-soft mt-1 block">{point.body}</span>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  )
}
